import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthAPI } from 'src/app/providers/authentication.api.service';
import { EventsAPI } from 'src/app/providers/events.api.service';
@Component({
  selector: 'app-host-create-toypool-goodie-boxes',
  templateUrl: './host-create-toypool-goodie-boxes.component.html',
  styleUrls: ['./host-create-toypool-goodie-boxes.component.scss'],
})
export class HostCreateToypoolGoodieBoxesComponent implements OnInit {
  eventId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authAPI: AuthAPI,
    private eventService: EventsAPI
  ) {}

  async ngOnInit() {
    const token = await this.authAPI.getAnonToken();
    this.route.params.subscribe(async (params) => {
      this.eventId = params['eventId'];
      const eventResponse = await this.eventService.getEvent(this.eventId, token).toPromise();
      const loadedEvent = (eventResponse as any).event;
    });
  }

  gotoToypoolCheckout() {
    this.router.navigate(['/host/create/checkout']);
  }

  gotoHostCreateInvite() {
    this.router.navigate(['/host/create/invite']);
  }
}
